import BlockContent from '@sanity/block-content-to-react'
import imageUrlBuilder from '@sanity/image-url'
import { Col, Row } from 'antd'
import { darken } from 'polished'
import React, { Fragment } from 'react'
import { Head, withRouteData, withSiteData } from 'react-static'
import styled, { withTheme } from 'styled-components'
import Hero from '../components/Hero'
import Seperator from '../components/Seperator'
import getSerializers from '../utils/sanitySerializers'
// import Talkyard from '../components/Talkyard'

const TopHero = styled(Hero)`
  color: ${p => p.theme.textOffwhite};
  padding-bottom: 6px;
`

const Preface = styled.p`
  white-space: pre-line;
  font-size: 1.3em;
`

const StCol = styled(Col)`
  color: ${p => p.theme.textGrey};

  h2 + h3 {
    margin-top: 0;
  }

  h2,
  h3 {
    color: #fff;
    &:not(:first-child) {
      margin-top: 1.5em;

      & + h3,
      & + h2 {
        margin-top: 0;
      }
    }
    code {
      color: ${p => p.theme.textGrey};
      font-size: 92%;
      margin-top: -10px;
    }
  }

  ul {
    list-style: square;
  }
`

class Article extends React.Component {
  constructor(props) {
    super(props)

    const { marks, types } = getSerializers(props.siteData)

    this._serializers = {
      marks,
      types: {
        image: types.image,
      },
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      heroImageSrc: imageUrlBuilder(nextProps.siteData.sanityConfig)
        .image(nextProps.article.mainImage)
        .url(),
    }
  }

  render() {
    const {
      article: { title, preface, prefaceBlock, body, meta, mainImage },
      siteData: {
        sanityConfig: { projectId, dataset },
        // talkyardServerUrl,
      },
      theme,
    } = this.props

    let chosenPreface = prefaceBlock ? (
      <BlockContent blocks={prefaceBlock} serializers={this._serializers} />
    ) : (
      preface
    )

    const metaDescription =
      meta && meta.description ? (
        <meta name="description" content={meta.description} />
      ) : null

    const metaTitle = <title>{(meta && meta.title) || title}</title>

    return (
      <Fragment>
        <Head>
          {metaTitle}
          {metaDescription}
        </Head>
        <TopHero
          imagePlaceholder={mainImage.metadata.lqip}
          imageSrc={this.state.heroImageSrc}
          trace={this._heroImageSrc}
          color={darken(0.1, theme.main)}
          isCentered
          parallaxOffset={200}
          opacity={0.2}
          minHeight="40vh"
        >
          <Row type="flex" align="middle" justify="center">
            <Col xs={22} sm={20} md={18} lg={16} xl={14}>
              <h1>{title}</h1>
              <Preface>{chosenPreface}</Preface>
            </Col>
          </Row>
        </TopHero>
        <Seperator />
        <Row
          style={{ margin: '50px 0' }}
          type="flex"
          align="middle"
          justify="center"
        >
          <StCol xs={20} sm={20} md={16} lg={12}>
            <BlockContent
              blocks={body}
              serializers={this._serializers}
              imageOptions={{ w: 650, h: 300, fit: 'max' }}
              projectId={projectId}
              dataset={dataset}
            />
            {/*             {showComments && (
              <Talkyard
                style={{ marginTop: '60px' }}
                serverUrl={talkyardServerUrl}
                discussionId={id}
              />
            )} */}
          </StCol>
        </Row>
        <Seperator />
      </Fragment>
    )
  }
}

export default withSiteData(withRouteData(withTheme(Article)))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Article.jsx